import { createApp, markRaw } from "vue";
import { createPinia } from "pinia";
import OneSignalVuePlugin from "@onesignal/onesignal-vue3";
import { growthBookPlugin } from "./utils/growthbook/growthbook";
import piniapersist from "pinia-plugin-persistedstate";

import App from "./App.vue";
import router from "./router";
import { vSanitizedHtml } from "./directives/sanitizedHtml";

import "./assets/style.css";
import { isGepPwaInstallPromptEnabled, registerGepPwa } from "./utils/gepPwa";
import { initInstallPrompt } from "./utils/installPrompt";
import { captureOriginalScanUrl } from "./utils/shortcutEntry";

const app = createApp(App);
app.directive("sanitized-html", vSanitizedHtml);
const currentUrl = window.location.href;
const FFEndpoint = import.meta.env.VITE_FF_ENDPOINT;
const browserInfo = navigator.userAgent.toLowerCase();

let appId: string =
  import.meta.env.VITE_HOMEPAGE_APP_ID ||
  "dcc2e5ee-c9bb-4c4b-80d3-893980993be1";
if (currentUrl.includes("app"))
  appId =
    import.meta.env.VITE_HOMEPAGE_APP_ID_APP ||
    "dcc2e5ee-c9bb-4c4b-80d3-893980993be1";

const pinia = createPinia();
pinia.use(piniapersist);
pinia.use(({ store }) => {
  store.router = markRaw(router);
});
app.use(router);
app.use(pinia);
app.use(growthBookPlugin, {
  featuresEndpoint: FFEndpoint,
});

// Chrome fires `beforeinstallprompt` before Home mounts, so listen from boot.
initInstallPrompt();
// Remember the scan link before the router strips it, so a Home Screen shortcut
// can reopen it. Pilot page only; other hotels store nothing.
if (isGepPwaInstallPromptEnabled()) captureOriginalScanUrl();

if (browserInfo.includes("iphone") || browserInfo.includes("ipad")) {
  app.mount("#app");
} else {
  app
    .use(OneSignalVuePlugin, {
      appId: appId,
    })
    .mount("#app");
}

registerGepPwa();
